var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47613 2.72559H8.52398C8.43935 2.72559 8.39703 2.76465 8.39703 2.84277V7.44275H3.66797C3.58333 7.44275 3.54102 7.48181 3.54102 7.55994V8.43884C3.54102 8.51697 3.58333 8.55603 3.66797 8.55603H8.39703V13.1553C8.39703 13.2334 8.43935 13.2725 8.52398 13.2725H9.47613C9.56077 13.2725 9.60308 13.2334 9.60308 13.1553V8.55603H14.332C14.4167 8.55603 14.459 8.51697 14.459 8.43884V7.55994C14.459 7.48181 14.4167 7.44275 14.332 7.44275H9.60308V2.84277C9.60308 2.76465 9.56077 2.72559 9.47613 2.72559Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6e80dd719b68c3a7c171cc7be5021541.svg";
export { ForwardRef as ReactComponent };